import React from 'react'

import styled from '@emotion/styled'
import StyleVariales from '../../styles/marketing'

// STYLE ##########################################################

const sv = StyleVariales;

const VideoInfo = styled(`div`)`
  color: ${sv.colors.headline};
  ${sv.flexRow};
`;

const VideoTitle = styled(`div`)`
  font: ${sv.h2}
  margin: 10px 0px;
`;

// COMPONENT ##########################################################

const GistVideoDetails = (props) => {
  const {info} = props;
  return (
      <>
        {info &&
        <VideoInfo>

          <VideoTitle>
            {info.title}
          </VideoTitle>

        </VideoInfo>
        }
      </>
  )
};

export default GistVideoDetails
